import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'redux/reducers/rootReducer';

const summaryActiveCustomers = (state: RootState) =>
  state.homeDashboard.summary.activeCustomers;
const summaryActiveAssignments = (state: RootState) =>
  state.homeDashboard.summary.activeAssignments;
const summaryTimesheetStatusReport = (state: RootState) =>
  state.homeDashboard.summary.timesheetStatusReport;
const summaryAssignmentsEndingSoon = (state: RootState) =>
  state.homeDashboard.summary.assignmentsEndingSoon;

export const summaryOverviewLoadingSelector = createSelector(
  summaryActiveAssignments,
  (summaryActiveAssignments) =>
    summaryActiveAssignments.loading && !summaryActiveAssignments.data,
);
export const summaryDetailsLoadingSelector = createSelector(
  summaryActiveCustomers,
  summaryActiveAssignments,
  summaryTimesheetStatusReport,
  summaryAssignmentsEndingSoon,
  (
    summaryActiveCustomers,
    summaryActiveAssignments,
    summaryTimesheetStatusReport,
    summaryAssignmentsEndingSoon,
  ) =>
    summaryActiveCustomers.loading ||
    summaryActiveAssignments.loading ||
    summaryTimesheetStatusReport.loading ||
    summaryAssignmentsEndingSoon.loading,
);
export const summaryActiveCustomersDataSelector = createSelector(
  summaryActiveCustomers,
  (summaryActiveCustomers) => summaryActiveCustomers.data,
);
export const homeDashboardOverviewLoadingSelector = createSelector(
  summaryOverviewLoadingSelector,
  (summaryOverviewLoadingSelector) => summaryOverviewLoadingSelector, // || prefferedOverviewLoading || financilasOberviewLoading
);
export const summaryActiveAssignmentsDataSelector = createSelector(
  summaryActiveAssignments,
  (summaryActiveAssignments) => summaryActiveAssignments.data,
);
export const summaryTimesheetStatusReportDataSelector = createSelector(
  summaryTimesheetStatusReport,
  (summaryTimesheetStatusReport) => summaryTimesheetStatusReport.data,
);
export const summaryAssignmentsEndingSoonDataSelector = createSelector(
  summaryAssignmentsEndingSoon,
  (summaryAssignmentsEndingSoon) => summaryAssignmentsEndingSoon.data,
);
